// Limestone Theme System
// Light/Dark mode tokens derived from approved v4 design

export const themes = {
  light: {
    bg: '#fdfbf7',
    bgSubtle: '#f9f5ed',
    surface: '#ffffff',
    surfaceElevated: '#ffffff',
    text: '#3D2412',
    textSecondary: 'rgba(61,36,18,0.55)',
    textTertiary: 'rgba(61,36,18,0.3)',
    accent: '#3D2412',
    accentSubtle: 'rgba(61,36,18,0.04)',
    border: 'rgba(61,36,18,0.08)',
    borderHover: 'rgba(61,36,18,0.25)',
    borderStrong: '#d6d3d1',
    navBg: 'rgba(253,251,247,0.8)',
    glow: 'rgba(61,36,18,0.04)',
    buttonBg: '#3D2412',
    buttonText: '#fef3c7',
    buttonSecondaryBg: 'transparent',
    buttonSecondaryText: '#3D2412',
    buttonSecondaryBorder: '#d6d3d1',
    buttonSecondaryBorderHover: '#3D2412',
    gradientHero: 'linear-gradient(180deg, rgba(61,36,18,0.03) 0%, transparent 50%)',
    cardShadow: '0 1px 3px rgba(61,36,18,0.05), 0 8px 24px rgba(61,36,18,0.06)',
    navShadow: '0 1px 12px rgba(61,36,18,0.06)',
    featuredBg: 'rgba(255,255,255,0.7)',
    overlayBg: 'rgba(0, 0, 0, 0.5)',
    modalBg: '#fef3c7',
    inputBg: '#ffffff',
    inputBorder: '#d6d3d1',
    inputFocusBorder: '#3D2412',
    tagBg: '#fef3c7',
    tagBorder: '#d6d3d1',
    success: '#16a34a',
    successBg: '#f0fdf4',
    error: '#dc2626',
    errorBg: '#fef2f2',
    skeleton: '#e8e5e0',
    skeletonShine: '#f5f2ed',
    cream: '#fef3c7',
  },
  dark: {
    bg: '#110b07',
    bgSubtle: '#1c1209',
    surface: '#1c1209',
    surfaceElevated: '#261a0e',
    text: '#f5e6c8',
    textSecondary: 'rgba(245,230,200,0.5)',
    textTertiary: 'rgba(245,230,200,0.3)',
    accent: '#d4a574',
    accentSubtle: 'rgba(212,165,116,0.1)',
    border: 'rgba(245,230,200,0.08)',
    borderHover: 'rgba(245,230,200,0.2)',
    borderStrong: 'rgba(245,230,200,0.15)',
    navBg: 'rgba(17,11,7,0.8)',
    glow: 'rgba(212,165,116,0.06)',
    buttonBg: '#f5e6c8',
    buttonText: '#110b07',
    buttonSecondaryBg: 'transparent',
    buttonSecondaryText: '#f5e6c8',
    buttonSecondaryBorder: 'rgba(245,230,200,0.15)',
    buttonSecondaryBorderHover: '#d4a574',
    gradientHero: 'linear-gradient(180deg, rgba(212,165,116,0.08) 0%, transparent 60%)',
    cardShadow: 'none',
    navShadow: 'none',
    featuredBg: 'transparent',
    overlayBg: 'rgba(0, 0, 0, 0.7)',
    modalBg: '#1c1209',
    inputBg: '#261a0e',
    inputBorder: 'rgba(245,230,200,0.15)',
    inputFocusBorder: '#d4a574',
    tagBg: 'rgba(212,165,116,0.1)',
    tagBorder: 'rgba(245,230,200,0.15)',
    success: '#4ade80',
    successBg: '#0f2a1a',
    error: '#f87171',
    errorBg: '#2a0f0f',
    skeleton: '#261a0e',
    skeletonShine: '#332211',
    cream: '#261a0e',
  },
};